// extracted by mini-css-extract-plugin
export default {"header":"factSheetReport_header__OaWNQ","headerTitle":"factSheetReport_headerTitle__R0QYp","content":"factSheetReport_content__lrml0","divider":"factSheetReport_divider__HWJpY"};